import React from "react";
import { Hero } from "@/components/home/Hero";
import { Stats } from "@/components/home/Stats";
import { BrandMarquee } from "@/components/home/Marquee";
import { Manifesto } from "@/components/home/Manifesto";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { ServiceArea } from "@/components/home/ServiceArea";
import { QuoteForm } from "@/components/home/QuoteForm";
import { Testimonials } from "@/components/home/Testimonials";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Stats />
      <BrandMarquee />
      <Manifesto />
      <ServicesGrid />
      <WhyChooseUs />
      <ServiceArea />
      <Testimonials />
      <QuoteForm />
    </div>
  );
}
